import { faChevronDown, faChevronUp, faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  MEDIUM_GRAY,
  translate,
  useAuthentication,
  userPermissionSelector,
  isLoadingUserDataSelector,
} from "@shape/reef-shared";
import { Routes } from "routes";
import UserMenu from "./UserMenu";
import { Container, SignIn, UserMenuGreeting } from "./styled";

function UserInfo() {
  const navigate = useNavigate();
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);

  const { username, isLoading } = useAuthentication();
  const userPermission = useSelector(userPermissionSelector);
  const isLoadingUserData = useSelector(isLoadingUserDataSelector);

  const login = () => {
    navigate(Routes.LoginPage);
  };

  return (
    <Container>
      {isLoading ? (
        <FontAwesomeIcon data-testid="user-loading" icon={faCircleNotch} spin size="1x" />
      ) : null}
      {!isLoading && username ? (
        <>
          <UserMenuGreeting
            data-testid="user-photo"
            isMenuOpen={isUserMenuOpen}
            onClick={() => setIsUserMenuOpen(true)}
            onKeyUp={(e) => e.keyCode === 13 && setIsUserMenuOpen(true)}
            role="button"
            tabIndex={0}
          >
            {username && translate("hi", { name: username })}
            <FontAwesomeIcon
              icon={isUserMenuOpen ? faChevronUp : faChevronDown}
              color={MEDIUM_GRAY}
              size="1x"
            />
          </UserMenuGreeting>
          <UserMenu
            setIsOpen={setIsUserMenuOpen}
            isOpen={isUserMenuOpen}
            user={userPermission}
            username={username}
          />
        </>
      ) : null}
      {!isLoading && !isLoadingUserData && !username ? (
        <SignIn
          data-testid="user-sign-in"
          onClick={login}
          onKeyUp={(e) => e.keyCode === 13 && login()}
          role="button"
          tabIndex={0}
        >
          {translate("signIn")}
        </SignIn>
      ) : null}
    </Container>
  );
}

export default UserInfo;
